export default __webpack_public_path__ + "static/media/Background.fb87b6a8.svg";